import { SUPPLIERS_PERMISSIONS_TO_VIEW } from '@wellbeingxltd/fe-lib/constants'

// Checking if vouchersPage should be visible and return accessToPage boolean value
export const isAllowedRoute = ({ key, accessToPages }) => {
    if (!accessToPages || !key) return

    const { isVoucherSupplier, supplierId } = JSON.parse(localStorage.getItem('supplier'))
    if (!isVoucherSupplier) {
        console.warn(`isVoucherSupplier property is absent for supplierId=${supplierId}`)
    }

    if (key === SUPPLIERS_PERMISSIONS_TO_VIEW.vouchersPage.value) {
        return isVoucherSupplier && accessToPages[key]
    }
    return accessToPages[key]
}

// Get pages that user has access. Return array
export const getAllowedPages = accessToPages =>
    accessToPages
        ? Object.entries(accessToPages)
              .filter(([key, value]) => value && isAllowedRoute({ key, accessToPages }))
              .map(([key, value]) => key)
        : null
